export const REGISTER_PUSH_ENDPOINT = 'REGISTER_PUSH_ENDPOINT';
export const REGISTERED_PUSH_ENDPOINT = 'REGISTERED_PUSH_ENDPOINT';
export const REGISTER_API_ERROR_RECEIVED = 'REGISTER_API_ERROR_RECEIVED';
